/**
 * Literal translation keys for the occupancy enums (POS2-1259).
 *
 * Lookup tables, never ``t(`occupancy.type.${x}`)``: `check:i18n` resolves keys statically, so a
 * key built at runtime is invisible to it and the string escapes the catalogue while every gate
 * stays green. Shared so the four surfaces that render a type or a style cannot drift apart.
 */
import type { EventType, ServiceStyle } from "@/hooks/use-occupancy";

export const SERVICE_STYLES: ServiceStyle[] = [
  "plated",
  "buffet",
  "family_style",
  "canapes",
  "day_delegate",
];

export const TYPE_LABEL_KEYS: Record<EventType, string> = {
  wedding: "occupancy.type.wedding",
  conference: "occupancy.type.conference",
  function: "occupancy.type.function",
  banquet: "occupancy.type.banquet",
  general: "occupancy.type.general",
  other: "occupancy.type.other",
};

export const SERVICE_STYLE_LABEL_KEYS: Record<ServiceStyle, string> = {
  plated: "occupancy.serviceStyle.plated",
  buffet: "occupancy.serviceStyle.buffet",
  family_style: "occupancy.serviceStyle.family_style",
  canapes: "occupancy.serviceStyle.canapes",
  day_delegate: "occupancy.serviceStyle.day_delegate",
};

export const WEEKDAY_LABEL_KEYS: Record<number, string> = {
  1: "occupancy.weekday.mon",
  2: "occupancy.weekday.tue",
  3: "occupancy.weekday.wed",
  4: "occupancy.weekday.thu",
  5: "occupancy.weekday.fri",
  6: "occupancy.weekday.sat",
  7: "occupancy.weekday.sun",
};
